module.exports = __webpack_public_path__ + "img/gift.b17c8608.png";